import { FC } from "react";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";
import { iDataOrganizacion } from "../../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { Button, IconButton, Tooltip } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useSuperAdminOrganization } from "../../../context/SuperAdmin/OrganizationContext";
import { useNavigate } from "react-router-dom";
import { formatFechaWithHour } from "../../../utils/dateFunctions";

interface Props {
  org: iDataOrganizacion;
  index: number;
}

const ProfileRowOrg: FC<Props> = ({ index, org }) => {
  const navigate = useNavigate();
  const { assignToDeleteOrg, handleEdit } = useSuperAdminOrganization();

  //Se ejecuta al seleccionar los usuarios de la tabla en el boton accion
  const handleUsers = (idOrganizacion: string) => {
    navigate(`/asistente/organizations/${idOrganizacion}`);
  };

  return (
    <StyledTableRow>
      <StyledTableCell sx={{ mb: 2 }} align="left">
        {index + 1}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }} align="left">
        {org.nombre}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }} align="left">
        {org.pais}
      </StyledTableCell>
      <StyledTableCell align="left">
        {formatFechaWithHour(org.updated_at)}
      </StyledTableCell>
      <StyledTableCell align="left">{org.estado}</StyledTableCell>
      <StyledTableCell align="center">
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleEdit(org)}
        >
          <Tooltip title="Editar organización">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => assignToDeleteOrg(org.id_organizacion)}
        >
          <Tooltip title="Eliminar organización">
            <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleUsers(org.id_organizacion)}
        >
          <Tooltip title="Ver organización">
            <IconButton aria-label="usuarios" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default ProfileRowOrg;
